// extracted by mini-css-extract-plugin
export default {"wrapper":"w1-z","play":"x1-z"};